import React from 'react';
import { Box, Typography } from '@mui/material';
import { GradientCard, RoundedImage } from '../utilComponents/StyledComponents';

const RosterCard = ({ onClick, firstName, lastName, imageUrl, startcolor, endcolor }) => {
  return (
    <GradientCard startcolor={startcolor} endcolor={endcolor} onClick={onClick}>
      {/* Name Section */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Press Start 2P", sans-serif',
            fontWeight: 'bold',
            fontSize: '.75rem',
            color: 'white',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '5px', // Space between first and last names
          }}
        >
          {firstName}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Press Start 2P", sans-serif',
            fontWeight: 'bold',
            fontSize: '.75rem',
            color: 'white',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
            letterSpacing: '2px',
            textTransform: 'uppercase',
          }}
        >
          {lastName}
        </Typography>
      </Box>

      {/* Player Image */}
      <RoundedImage src={imageUrl} alt={`${firstName} ${lastName}`} />
    </GradientCard>
  );
};

export default RosterCard;
